import React from "react";

import "../../assets/css/bootstrap.min.css";
import "../../assets/css/all.min.css";
import "../../assets/css/swiper-bundle.min.css";
import "../../assets/css/magnific-popup.css";
import "../../assets/css/animate.css";
import "../../assets/css/nice-select.css";
import "../../assets/css/style.css";

import { Link } from 'react-router-dom';

const Statistics = () => {
  return (
    <div>
      

      <section className="statistic-area pt-60">
        <div className="container">
          <div className="row g-4">
            <div className="col-xl-1"></div>
            <div className="col-xl-5">
              <div className="image">
                <img
                  src="/images/service/service-three-image3.png"
                  alt="leaf"
                />
              </div>
            </div>
            <div className="col-xl-5">
              <div className="section-header2">
                <h2
                  className="wow fadeInUp"
                  data-wow-duration="1.2s"
                  data-wow-delay=".2s"
                >
                  TREE PLANTING
                </h2>
                <h5
                  className="wow fadeInUp pt-10"
                  data-wow-duration="1.4s"
                  data-wow-delay=".4s"
                >
                  Today's Environmental Protection Safeguards Tomorrow
                </h5>
                
              </div>
              <div className="row g-4">
                <ul
                  className="wow mt-4 fadeInDown"
                  data-wow-duration="1.2s"
                  data-wow-delay=".2s"
                >
                    <li>
                    <img
                      className="pe-2"
                      src="/images/icon/leaf.png"
                      alt="icon"
                      style={{ display: "inline" }}
                    />
                      Planting/Tracking : bringing transparency to tree tagging space.( some basic info on planting and tracking )
                  </li>


                  <li>
                    <img
                      className="pe-2"
                      src="/images/icon/leaf.png"
                      alt="icon"
                      style={{ display: "inline" }}
                    />
                    Allow for tree planting initiatives and their donors to
                    verify that their purchased or donated trees have been
                    planted
                  </li>
                  <li>
                    <img
                      className="pe-2"
                      src="/images/icon/leaf.png"
                      alt="icon"
                      style={{ display: "inline" }}
                    />
                    Individual trees can be tracked to ensure that they grow
                    past the vulnerable sapling stage and continue to provide
                    valuable ecological services to their local environment.
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>
      
      <section className="statistic-area">
        <div className="container">
          <div className="row g-4">
            <div className="col-xl-1"></div>
            <div className="col-xl-5">
              <div className="section-header2">
                <h2
                  className="wow fadeInUp "
                  data-wow-duration="1.2s"
                  data-wow-delay=".2s"
                >
                   
                  TRACKING & VERIFICATION
                </h2>
                <h5
                  className="wow fadeInUp pt-10"
                  data-wow-duration="1.4s"
                  data-wow-delay=".4s"
                >
                  Tree Tracking & Verification for a Sustainable Tomorrow.
                </h5>
                 
              </div>
              <div className="row g-4">
                <ul
                  className="wow mt-4 fadeInDown"
                  data-wow-duration="1.2s"
                  data-wow-delay=".2s"
                >

<li>
                    <img
                      className="pe-2"
                      src="/images/icon/leaf.png"
                      alt="icon"
                      style={{ display: "inline" }}
                    />
                  Your tree photo is screened by our team. Once a tree is verified, eligible planters will be paid for their stewardship.
                  </li>


                  <li>
                    <img
                      className="pe-2"
                      src="/images/icon/leaf.png"
                      alt="icon"
                      style={{ display: "inline" }}
                    />
                    Tree farmers can take periodic geotagged photos of their
                    tree(s). These images are verified by our team and the tree
                    farmer is paid for their efforts
                  </li>
                  <li>
                    <img
                      className="pe-2"
                      src="/images/icon/leaf.png"
                      alt="icon"
                      style={{ display: "inline" }}
                    />
                    Our data-driven system is shifting the focus from simply
                    planting trees to growing diverse forests. We value the
                    process of growing trees by verifying the incremental growth
                    of each tree. The data is then packaged into a tree wallet
                    system so that it can be accessed and traded by users
                    anywhere in the world.
                  </li>
                </ul>
              </div>
            </div>

            <div className="col-xl-6">
              <div className="image">
                <img
                  src="/images/service/service-three-image4.png"
                  alt="service"
                />
              </div>
            </div>
          </div>
        </div>
      </section>










      <section className="statistic-area">
        <div className="container">
          <div className="row g-4">
            <div className="col-xl-1"></div>
            <div className="col-xl-5">
              <div className="image">
              <img
                  src="/images/service/service-three-image5.png"
                  alt="leaf"
                />
              </div>
            </div>
            <div className="col-xl-5">
              <div className="section-header2">
                <h2
                  className="wow fadeInUp"
                  data-wow-duration="1.2s"
                  data-wow-delay=".2s"
                >
                  TREE TAGGING
                </h2>
                <h5
                  className="wow fadeInUp pt-10"
                  data-wow-duration="1.4s"
                  data-wow-delay=".4s"
                >
                  Nurturing Nature, Tree Tagging for a Greener Legacy
                </h5>
                
              </div>
              <div className="row g-4">
                <ul
                  className="wow mt-4 fadeInDown"
                  data-wow-duration="1.2s"
                  data-wow-delay=".2s"
                >
                    <li>
                    <img
                      className="pe-2"
                      src="/images/icon/leaf.png"
                      alt="icon"
                      style={{ display: "inline" }}
                    />
                      Tags are used for many purposes including, but not limited to: identification of trees to cut down, trees to protect, treated trees, species and genus names and memorial trees. </li>


                  <li>
                    <img
                      className="pe-2"
                      src="/images/icon/leaf.png"
                      alt="icon"
                      style={{ display: "inline" }}
                    />
                   Tree tags are used by the Department of Forestry, researchers, tree farmers, national and local parks, landscapers and more. 
                  </li>
                  <li>
                    <img
                      className="pe-2"
                      src="/images/icon/leaf.png"
                      alt="icon"
                      style={{ display: "inline" }}
                    />
                    All tags are customizable to meet your needs from a stamped serial number all the way up to a laser etched QR code. 
                    New UV stable black aluminium tags stand up to sunlight and outdoor conditions for years!                  
                  </li>
                </ul>                
              </div>
              <div><br></br></div>
              {/* <a
                href="/upload"
                className="btn-one wow fadeInUp"
                data-wow-duration="1.5s"
                data-wow-delay=".5s"
              >
                <span>Register your Tree</span>
                <i className="fa-solid fa-angles-right"></i>
              </a> */}
                 <Link
      to="/upload"
      className="btn-one wow fadeInUp"
      data-wow-duration="1.5s"
      data-wow-delay=".5s"
    >
      <span>Register your Tree</span>
      <i className="fa-solid fa-angles-right"></i>
    </Link>
              <div><br></br></div>
            </div>
          </div>
        </div>
      </section>


    </div>
  );
};

export default Statistics;